<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
            autocomplete="off"
        >
            <b-sidebar id="send_whats" aria-labelledby="sidebar-no-header-title" no-header backdrop width="850px" style="direction:ltr" right title="إضافة ملاحظة" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:140px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span>ارسال واتس اب</span>
                        </div>
                        <div @click="hide" id="hideaddHomeTaskss" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{ lang.close }}</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <v-row style="direction:rtl" class="m-2">
                        <v-col cols="12" md="12">
                            <label>اختر القالب</label>
                            <b-form-select class="selborder" v-model="templateId" :options="TemplatesIds" />
                        </v-col>
                        
                        
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="12" md="6" v-for="(item,index) in templateVars" :key="index">
                                    <label>{{ item.text }}</label>
                                    <b-form-input class="inborder" v-model="varsValues[index]" />
                                </v-col>
                                
                            </v-row>
                        </v-col>
                    </v-row>
                </template>
                <template #footer="">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                        <b-button type="button" @click="addJob()" variant="success" class="ma-2" style="width:100px;">ارسل</b-button>
                    </div>
                </template>
            </b-sidebar>
        </v-form>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify'
export default{
    data() {
        return {
            showConvertedTo: false,
            TemplatesIds: [],
            customers: [],
            templateId: '',
            varsValues: [],
            mobile: '',
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        templateVars: function () {
            let t = [];
            for(let i=0; i< this.TemplatesIds.length; i++){
                if(this.TemplatesIds[i].value == this.templateId){
                    return this.TemplatesIds[i].vars;
                }
            }
            return t; 
        }
    },
    methods: {
        
        addJob(){
            let message = '';
            let co = true;
            if(this.templateVars.length > 0){
                for(let i = 0; i< this.varsValues.length; i++){
                    if(this.varsValues[i] == "") {
                        message = "يجب عليك تعبئة جميع الحقول الخاصة بمتغيرات القالب";
                        co = false;
                    }
                }
            }
            else if(this.templateId == ''){
                message = "يجب اختيار قالب"
                co = false;
            }
            else if(this.mobile == ''){
                message = "يجب ان يكون رقم الاتصال معرف كواتس اب ولا يكون فارغا"
                co = false;
            }
            
            if(!co) {
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
            
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","sendWhatsTemplates")
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append("data[templateId]",this.templateId)
            post.append("data[mobile]",this.mobile)
            post.append("data[vars]",JSON.stringify(this.varsValues))
            
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => { 
                this.TemplatesIds = response.data.results.data;
            });
        },
        getTemplates()
        {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getWhatsTemplates")
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append(`data[active]`,"1")

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => { 
                console.log("templates: ", response.data);
                this.TemplatesIds = response.data.results.data;
            });
        },

    },
    created() {
        this.getTemplates()
    },
}
</script>
<style scoped>
.itemSel{
    margin:2px;
    color:#fff;
    text-align: center;
    padding:5px;
    cursor: pointer;
}
</style>